import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import("../views/Login.vue"),
  },
  {
    path: "/Index",
    name: "index",
    component: () =>
      import("../views/Index.vue"),
  },
  {
    path: "/caseInfo/:id",
    name: "caseInfo",
    component: () =>
      import("../views/page/caseInfo.vue"),
  },
  {
    path: "/shareInfo/:id",
    name: "shareInfo",
    component: () =>
      import("../views/page/shareInfo.vue"),
    meta: { requiresAuth: false } // 标记为无需认证
  },
  {
    path: "/albumInfo/:id",
    name: "albumInfo",
    component: () =>
      import("../views/page/albumInfo.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false);

  /*if (!token && requiresAuth && to.path !== '/') {
    next({ path: '/' });
  } else {
    next();*/
  if (to.path.startsWith('/slideViewer/viewer')) {
    const token = sessionStorage.getItem('token');
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
      return;
    }
  }
  next();

})

export default router;
